import React from 'react';
import { element, number, string } from 'prop-types';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { DynamicComponent } from '@thd-nucleus/app-render';
import { Card, CardTitle } from '@thd-olt-component-react/core-ui';
import { SponsoredCarousel } from '@thd-olt-component-react/sponsored-content';

import classnames from 'classnames/bind';
import componentStyles from '../components.module.scss';

import { AUTHORIZATION_STATUS } from '../../utils';

const styles = classnames.bind(componentStyles);

export function CustomRenderedSponsoredProducts({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,

  userAuthStatus,
  customRenderId,
  slidesPer,
}) {
  return (
    <DynamicComponent pageType="homepage">
      <Hydrator
        id="sponsoredProducts-php-hydrator"
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        delay={HOMEPAGE_DELAY_STANDARD}
        placeholder={PLACEHOLDER}
        preserveCtxVal="clientStore"
      >
        <Card>
          {/**
           * @TODO
           * Refactor `app.scss` to use CSS Modules.
           */}
          <CardTitle
            className="card__title u-width-100 "
            title="Sponsored Products"
          />
          <div className="u-width-100 sponsored-carousel">
            <SponsoredCarousel
              slidesPer={slidesPer}
              customRenderId={customRenderId}
              hideTitle
              pageContext={{
                schema:
                  userAuthStatus === AUTHORIZATION_STATUS.GUEST
                    ? 'hp_sponsored'
                    : 'hp_sponsored_auth',
              }}
              noATCFulfillment
              utilizeRvData
            />
          </div>
        </Card>
      </Hydrator>
    </DynamicComponent>
  );
}

CustomRenderedSponsoredProducts.propTypes = {
  SCROLL_BUFFER: number,
  HOMEPAGE_DELAY_STANDARD: number,
  PLACEHOLDER: element,

  userAuthStatus: string,
  customRenderId: string,
  slidesPer: number,
};

CustomRenderedSponsoredProducts.defaultProps = {
  SCROLL_BUFFER: undefined,
  HOMEPAGE_DELAY_STANDARD: undefined,
  PLACEHOLDER: undefined,

  userAuthStatus: undefined,
  customRenderId: undefined,
  slidesPer: undefined,
};
